import { css } from '@emotion/react';
import { Box, Text } from '@inflearn/ds-react';
import { SPEAKER_SESSION_PLACE_TYPE } from '../commons/constants';
import ShareTableRow from './ShareTableRow';
import { shareScheduleRowDatas, type Schedule } from '../../../dtos/ShareScheduleDto';
import { useEffect, useRef, useState } from 'react';

type Props = {
  schedulesTable: Schedule[][];
};

const ShareTable = ({ schedulesTable }: Props) => {
  const shareTableRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  const onTableResize = () => {
    const MAX_WIDTH = 462;
    const MAX_HEIGHT = 561;
    if (shareTableRef.current !== null) {
      const { width } = shareTableRef.current.getBoundingClientRect();
      const calculatedScale = width / MAX_WIDTH > 1 ? 1 : width / MAX_WIDTH;

      setScale(calculatedScale);

      shareTableRef.current.style.height = `${MAX_HEIGHT * calculatedScale}px`;
    }
  };

  useEffect(() => {
    window.addEventListener('resize', onTableResize);
  }, []);

  useEffect(() => {
    onTableResize();
  }, [schedulesTable]);

  return (
    <div css={{ width: '100%' }} ref={shareTableRef}>
      <Box
        component="article"
        css={[
          styleShareTable,
          {
            position: 'relative',
            left: '50%',
            transform: `translate(-50%) scale(${scale})`
          }
        ]}>
        <Box component="header" css={styleShareTableHeader}>
          <Text size="lg" color="black" weight="bold">
            SESSION TIMETABLE
          </Text>
          <Text size="xs" color="#333333" weight="bold">
            INFCON 2023
          </Text>
        </Box>
        <Box component="section" css={styleShareTableBody}>
          <Box></Box>
          {SPEAKER_SESSION_PLACE_TYPE.map((place) => (
            <Text
              size={14}
              weight="bold"
              css={{ opacity: 0.4, textAlign: 'center', lineHeight: 1 }}
              mb={16}
              key={place}>
              {place}
            </Text>
          ))}
          {schedulesTable.map((schedules, index) => (
            <ShareTableRow
              startedAt={shareScheduleRowDatas[index].startedAt}
              endedAt={shareScheduleRowDatas[index].endedAt}
              schedules={schedules}
              key={index}
            />
          ))}
        </Box>
      </Box>
    </div>
  );
};

const styleShareTable = css({
  width: '462px',
  maxWidth: '462px',
  aspectRatio: '462 / 561',
  backgroundColor: 'white',
  margin: '0',
  border: '1px solid #eeeeee',
  borderRadius: '16px',
  padding: '16px',
  transformOrigin: 'top'
});

const styleShareTableHeader = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: '1px solid black',
  paddingBottom: '12px',
  marginBottom: '12px'
});

const styleShareTableBody = css({
  display: 'grid',
  gridTemplateColumns: 'auto 1fr 1fr 1fr 1fr 1fr 1fr',
  gridTemplateRows: 'auto 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
  gridTemplateAreas:
    '". . . . . . ." ". . . . . . ." ". . . . . . ." ". . . . . . ." ". . . . . . prepare-networking" ". . . . . . prepare-networking" ". . . . . . networking" ". . . . . . networking"',
  gap: '4px',
  width: '100%'
});

export default ShareTable;
